import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SERVICE_TAG_TYPES } from "./Constants";
import { getTimeZone } from "./Functions/GetTimeZone";
import { getAccessToken } from "./Functions";

const baseUrl = `${import.meta.env.VITE_MESSAGE_CENTER_API_BASE_URL}`;

export const messageCenterBaseApi = createApi({
  reducerPath: "messageCenterBaseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseUrl,
    prepareHeaders: async (headers) => {
      const token = await getAccessToken();

      const timeZone = await getTimeZone();

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Strict-Transport-Security", "max-age=3600 ; includeSubDomains");
      headers.set("Ocp-Apim-Subscription-Key", import.meta.env.VITE_SUBSCRIPTION_KEY ?? "");

      headers.set("Accept", "*/*");
      headers.set("Accept-Encoding", "gzip, deflate, br");
      headers.set("Connection", "keep-alive");
      headers.set("X-timeZone", timeZone ?? "");
      return headers;
    },
  }),
  endpoints: () => ({}),
  tagTypes: Object.values(SERVICE_TAG_TYPES),
  keepUnusedDataFor: 1,
});
